import React from "react";
import {
  IconButton,
  HStack,
  Heading,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Tooltip,
} from "@chakra-ui/react";
import { MdOutlineDrafts, MdOutlineMarkunread } from "react-icons/md";
import moment from "moment";
export default function NotificationCard(props) {
  return (
    <Card
      size={"sm"}
      variant="unstyled"
      bg={props.elem.leidoNBS === false ? "brand.fondos_secundarios" : "white"}
      p={2}
    >
      <CardHeader>
        <HStack justifyContent={"space-between"} borderRadius={5}>
          <Heading
            size={"md"}
            fontWeight={"semibold"}
            color={"gray.600"}
            textAlign={"left"}
          >
            {props.elem.tituloNBS}
          </Heading>
          <Tooltip
            label={
              props.elem.leidoNBS === false
                ? "Marcar como leído"
                : "Marcar como no leído"
            }
          >
            <IconButton
              variant={"link"}
              onClick={() => props.handleLeido(props.elem)}
              cursor={"pointer"}
              icon={
                props.elem.leidoNBS === false ? (
                  <MdOutlineMarkunread />
                ) : (
                  <MdOutlineDrafts />
                )
              }
            />
          </Tooltip>
        </HStack>
      </CardHeader>
      {/*  onClick={() => openModal(elem)} */}
      <CardBody>
        <Heading size={"sm"} color={"gray"} fontWeight={"normal"}>
          {`${props.obtenerTextoAntesDelPunto(props.elem.descripciónNBS)}.`}
        </Heading>
      </CardBody>
      <CardFooter
        w={"100%"}
        size={"sm"}
        color={"gray"}
        fontWeight={"normal"}
        justifyContent={"end"}
      >
        {moment(props.elem.fechaCreacionNBS).format("DD/MM/YYYY HH:mm:ss")}
      </CardFooter>
    </Card>
  );
}
